module.exports = __webpack_public_path__ + "static/s4-2-buildings-d-e484439eb09196bb5e7a60e897970860.jpg";